<template>
  <div id="pageRoot">
    <p id="text01" class="textBase pageElement">
      Serafín se paró delante del hormiguero y dijo:<br /><br />
      — ¡Dejen en paz a las hormigas! ¡No permitiré que las molesten!<br /><br />
      Por no pelear con él, los dos hermanos tiraron las ramas que llevaban en
      las manos. Y enseguida siguieron andando.<br /><br />
      Al mediodía, llegaron a un lago en el que nadaban muchos patos. Los
      mayores buscaron piedras para practicar su puntería con las aves.<br /><br />
      Serafín se paró delante del lago y dijo:<br /><br />
      — ¡Dejen en paz a los patos! ¡No permitiré que los maten!<br /><br />
      Los mayores aceptaron a regañadientes y tiraron las piedras al costado.
      Los tres siguieron andando.<br /><br />
      Unos pasos mas adelante se toparon con una colmena repleta de miel.
    </p>
  </div>
</template>
<style scoped>
#text01 {
  position: absolute;
  width: 945px;
  height: 630px;
  left: 41px;
  top: 26px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 5b.mp4", "cas/Video 6b.mp4"],
    };
  },
};
</script>
